import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Row,
  Col
} from 'react-bootstrap';
import KeyMetrics from '../Components/key-metrics';
import LatestActivities from '../Components/latest-activities';
import NewRequestFromHomeownerTable from '../Components/new-request-from-homeowners-table';
import BarCharts from '../Components/bar-charts';
// import Skeleton, {SkeletonTheme} from 'react-loading-skeleton';
import * as DashBoardActionType from '../constants';
class BuilderDashBoard extends Component {
    static propTypes = {
      NewRequestDashBoardList: PropTypes.object,
      UserProfile: PropTypes.object,
      location: PropTypes.object,
      history: PropTypes.object,
      isLoading: PropTypes.bool,
      dispatch: PropTypes.func,
      KeyMetricsProfile: PropTypes.object,
      LatestActivitiesList: PropTypes.array,
      PageSizeReference: PropTypes.object,
      DashBoardStore: PropTypes.object,
      hasMoreActivities: PropTypes.bool,
      isLoadingMore: PropTypes.bool,
      FilterLatestActivitiesList: PropTypes.array,
      hasMoreData: PropTypes.bool,
      isLoadingMoreFilter: PropTypes.bool,
      LatestActivitiesScrollDown: PropTypes.array
    }

    constructor(props) {
      super(props);
      this.state = {
        userProfile: null
      };
    }

    componentWillReceiveProps(nextProps) {
      if (this.props.UserProfile !== nextProps.UserProfile) {
        this.setState({
          userProfile: nextProps.UserProfile
        });
      }
    }

    getBarChartsAndKeyMetrics = (params, callback) => {
      this.props.dispatch({
        type: DashBoardActionType.GET_KEY_METRICS_ASYNC,
        params: params,
        callback
      });
    }

    getLatestActivities = (params , callback) => {
      this.props.dispatch({
        type: DashBoardActionType.GET_LATEST_ACTIVITIES_LIST_ASYNC,
        params: params,
        callback
      });
    }

    getFilterLatestActivities = (params, callback) => {
      this.props.dispatch({
        type: DashBoardActionType.GET_LATEST_FILTER_ACTIVITIES_LIST_ASYNC,
        params: params,
        callback
      });
    }

    getNewRequestList = (params, callback) => {
      this.props.dispatch({
        type: DashBoardActionType.SEARCH_NEW_REQUEST_DASH_BOARD_LIST_ASYNC,
        params: params,
        callback
      });
    }

    getLatestActivitiesScrollDown = (params, callback) => {
      this.props.dispatch({
        type: DashBoardActionType.GET_LATEST_ACTIVITIES_WHEN_SCROLL_DOWN_ASYNC,
        params: params,
        callback
      });
    }

    render() {
      // const {userProfile} = this.state;
      return (
        <div>
          <div className='page-title clearfix'>
            <h2 className='pull-left'>Welcome {this.props.UserProfile.fullName}</h2>
          </div>
          {/* <SkeletonTheme color='#efe6e6'><Skeleton count={1} style={{height: 40, width: 300, marginBottom: 20}} /></SkeletonTheme> */}
          <Row xs={1} md={1} lg={2}>
            <KeyMetrics
              location={this.props.location}
              history={this.props.history}
              loading={this.props.isLoading}
              getKeyMetrics={this.getBarChartsAndKeyMetrics}
              KeyMetricsProfile={this.props.KeyMetricsProfile}
            />
          </Row>
          <Row>
            <Col xs={12} md={6} >
              <BarCharts
                location={this.props.location}
                history={this.props.history}
                loading={this.props.isLoading}
                getBarCharts={this.getBarChartsAndKeyMetrics}
                KeyMetricsProfile={this.props.KeyMetricsProfile}
              />
              <NewRequestFromHomeownerTable
                location={this.props.location}
                history={this.props.history}
                loading={this.props.isLoading}
                getNewRequestList={this.getNewRequestList}
                DashBoardStore={this.props.DashBoardStore}
                PageSizeReference={this.props.PageSizeReference}
                dispatch={this.props.dispatch}
              />
            </Col>
            <Col className='latest-activities-grid' xs={12} md={6} >
              <LatestActivities
                location={this.props.location}
                history={this.props.history}
                loading={this.props.isLoading}
                LatestActivitiesList={this.props.LatestActivitiesList}
                hasMoreActivities={this.props.hasMoreActivities}
                isLoadingMore={this.props.isLoadingMore}
                FilterLatestActivitiesList={this.props.FilterLatestActivitiesList}
                getFilterLatestActivities={this.getFilterLatestActivities}
                hasMoreData={this.props.hasMoreData}
                isLoadingMoreFilter={this.props.isLoadingMoreFilter}
                getLatestActivitiesScrollDown={this.getLatestActivitiesScrollDown}
                LatestActivitiesScrollDown={this.props.LatestActivitiesScrollDown}
              />
            </Col>
          </Row>
        </div>
      );
    }
}

const mapStateToProps = (state) => ({
  DashBoardStore: state.DashBoardStore,
  PageSizeReference: state.BuilderStore.PageSizeReference,
  NewRequestDashBoardList: state.DashBoardStore.NewRequestDashBoardList,
  UserProfile: state.UserStore.UserProfile,
  isLoading: state.DashBoardStore.isLoading,
  KeyMetricsProfile: state.DashBoardStore.KeyMetricsProfile,
  LatestActivitiesList: state.DashBoardStore.LatestActivitiesList,
  hasMoreActivities: state.DashBoardStore.hasMore,
  hasMoreData: state.DashBoardStore.hasMoreData,
  isLoadingMore: state.DashBoardStore.isLoadingMore,
  FilterLatestActivitiesList: state.DashBoardStore.FilterLatestActivitiesList,
  isLoadingMoreFilter: state.DashBoardStore.isLoadingMoreFilter,
  LatestActivitiesScrollDown: state.DashBoardStore.LatestActivitiesScrollDown
});

export default connect(mapStateToProps)(BuilderDashBoard);



// WEBPACK FOOTER //
// ./src/Dashboard/Containers/builder-dashboard.js